#= require_tree ./buttons

class CollapsibleBehavior
  constructor: ->
    new ExpandAllButton()
    new CollapseAllButton()

    # Prevent default events, so we don't get a page jump
    $(document).on 'click', '[data-toggle=collapse]', (e) ->
      e.preventDefault()
      # Specific to expanding response text
      $($(@).data('wrapper')).find('.response-wrap').toggleClass('truncate')

    $(document).on 'click', '[data-toggle="collapse"][data-replace-with]', (e) ->
      apply(e)

  apply = (e= {}) ->
    el = $(e.currentTarget)
    replace_text = el.data('replace-with')

    if el.text() is replace_text
      el.text el.data('replaced-text')
    else
      el.data 'replaced-text', el.text()
      el.text replace_text

global.CollapsibleBehavior = CollapsibleBehavior

export default CollapsibleBehavior